import { Box, Typography } from '@mui/material';
import Link from '@mui/material/Link';

type FooterMenuItemProps = {
    caption: string;
    onClick: () => void;
};

export default function FooterMenuItem({
    caption,
    onClick,
}: FooterMenuItemProps) {
    return (
        <Box display="flex" justifyContent="center" alignItems="center" mx={1}>
            <Link
                onClick={onClick}
                sx={{
                    color: 'var(--brand-text)',
                    textDecoration: 'none',
                    cursor: 'pointer',
                    '&:hover': { textDecoration: 'underline' },
                }}
            >
                <Typography variant="caption">{caption}</Typography>
            </Link>
        </Box>
    );
}
